import Vue from 'vue';

import store from '@/store';
import router from '@/router';

const EventBus = new Vue();

// Middleware method to check if user want's to leave from content editor without saving
function checkIfHasChanges (acceptMethod, abortMethod = null) {
  // If the current route is the content editor and has changes open's tha pop up alerting for unsaved changes
  if (['ContentEditor'].includes(router.history.current.name) && store.state.hasChanges) {
    EventBus.$emit('openUnsavedChangesAlert', { acceptMethod: acceptMethod, abortMethod: abortMethod }); // Calls the pop up using an event
  } else {
    acceptMethod();
  }
}

function clearCacheKeepAlive () {
  store.commit('setKeepAlive', false);
  setTimeout(() => {
    store.commit('setKeepAlive', true);
  }, 0);
}

function refreshSearchBar () {
  store.commit('setReloadSearchBar', false);
  setTimeout(() => {
    store.commit('setReloadSearchBar', true);
  }, 0);
}

const changeWorkspace = (workspace, route) => {
  if (workspace) {
    checkIfHasChanges(
      () => {
        store.commit('setWorkspace', workspace);
        clearCacheKeepAlive();
        refreshSearchBar();

        if (route.fullPath !== '/') {
          router.push('/');
        }
      }
    );
  }
};

export { EventBus, clearCacheKeepAlive, checkIfHasChanges, changeWorkspace, refreshSearchBar };
